import Footer from './footer';
import Header from './header';

const LayoutScreen = (props) => {
  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-lightCream to-cream">
      <div
        className={`flex flex-col flex-grow w-full h-full xl:max-w-screen-2xl mx-auto px-4 py-4 xl:px-20`}>

        {!props.hideHeader && <Header />}

        <section
          className={`${
            props.transparent ? 'bg-transparent' : 'bg-white'
          } relative flex flex-col flex-grow  xl:min-h-[750px] w-full mt-4 rounded-xl xl:rounded-3xl`}>
          {props.background && (
            <img
              src={props.background}
              className="hidden xl:block absolute z-0 top-0 left-0 w-full h-full object-cover object-right-bottom rounded-xl xl:rounded-3xl"
              alt=""
            />
          )}

          {props.children}
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default LayoutScreen;
